export const avoidBadCharacters = (fieldValue: string): string | undefined => {
  if (fieldValue.match(/[`^´¨]/) != null)
    return "this input shouldn't contain `^´¨characters";
};

export const validateKeydown = (
  event: React.KeyboardEvent<HTMLDivElement>
): void => {
  const inputTarget = event.target as HTMLInputElement;
  const allowedKey = inputTarget.id === 'bloodpressure-textfield' ? '/' : '.';
  const keyCode = event.keyCode ?? event.which;
  if (
    isNaN(Number(event.key)) &&
    event.key !== 'Backspace' &&
    event.key !== allowedKey &&
    !event.key.includes('Arrow')
  ) {
    event.stopPropagation();
    event.preventDefault();
  }
  if (keyCode === 190 && inputTarget.value.includes('.')) {
    event.preventDefault();
  }
};

export const bloodPressureValues = (bloodPressure: string): number[] => {
  if (bloodPressure.includes('/')) {
    const splittedBloodPressure =
      bloodPressure.split('/').length > 1
        ? bloodPressure.split('/')
        : [bloodPressure.split('/')[0], 0];
    return splittedBloodPressure.map(Number);
  }
  return [+bloodPressure, 0];
};
